module.exports = __webpack_public_path__ + "assets/img/help_image03-1.4ea5eac7.png";